import React, { useState } from "react";
import { useFormikContext } from "formik";
import { Table } from "react-bootstrap";
import { CheckIcon, EditIcon } from "Assets/icons";
import LoadingButton from "components/shared/LoadingButton";
import RichTextCell from "./RichTextCell";
import { errorMessageToast } from "helpers/common";
import { Edit2, Save } from "react-feather";

const AssessmentTable = ({ type }) => {
  const { values, setFieldValue } = useFormikContext();
  const { chartData = [] } = values;

  const [editingCell, setEditingCell] = useState(null);
  const [activeEditor, setActiveEditor] = useState(null); // track active editor

  const handleSave = (row, col, editor) => {
    try {
      const newValue = editor.getHTML();
      const updatedData = [...chartData];
      if (!updatedData[row]) {
        updatedData[row] = [];
      }
      updatedData[row][col] = newValue;

      setFieldValue("chartData", updatedData);
      setEditingCell(null);
      setActiveEditor(null);
    } catch(err) {
      console.error("Unable to save field value", err);
      errorMessageToast("Unable to save field value");
    }
  };

  return (
    <div className="table-cstm-design">
      {/* Shared toolbar */}
      <div className="mb-2 d-flex gap-2 toolbar">
        <button
          type="button"
          className={`btn btn-sm ${activeEditor?.isActive("bold") ? "btn-dark" : "btn-light"}`}
          onClick={() => activeEditor?.chain().focus().toggleBold().run()}
          disabled={!activeEditor}
        >
          <b><i className="fa fa-bold" aria-hidden="true"></i></b>
        </button>

        <button
          type="button"
          className={`btn btn-sm ${activeEditor?.isActive("italic") ? "btn-dark" : "btn-light"}`}
          onClick={() => activeEditor?.chain().focus().toggleItalic().run()}
          disabled={!activeEditor}
        >
          <i className="fa fa-italic" aria-hidden="true"></i>
        </button>

        <button
          type="button"
          className={`btn btn-sm ${activeEditor?.isActive("underline") ? "btn-dark" : "btn-light"}`}
          onClick={() => activeEditor?.chain().focus().toggleUnderline().run()}
          disabled={!activeEditor}
        >
          <u><i className="fa fa-underline" aria-hidden="true"></i></u>
        </button>

      </div>

      <Table bordered hover responsive className="table report-table mb-0">
        <thead>
          <tr>
            {Array.from({ length: type?.total_column || 0 }).map((_, colIndex) => {
              const isEditing =
                editingCell?.row === "header" &&
                editingCell?.col === colIndex;
              const cellValue = chartData?.[0]?.[colIndex] || "";

              return (
                <th
                  key={colIndex}
                  className="position-relative text-wrap"
                  style={{ width: "150px" }} // fixed width
                  // style={{ width: `${100/type?.total_column}%` }} // fixed width
                >
                  {isEditing ? (
                    <div className="d-flex align-items-center w-100">
                      <RichTextCell
                        value={cellValue}
                        onReady={(editor) => setActiveEditor(editor)}
                        onChange={() => handleSave(0, colIndex, activeEditor)}
                      />
                      <LoadingButton
                        variant="transparent"
                        className="cursor-pointer text-success ms-2"
                        onClick={() => handleSave(0, colIndex, activeEditor)}
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          padding: "2px 4px"
                        }}
                      >
                        <Save size={14} color="#333" />
                      </LoadingButton>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-between align-items-center">
                      <div dangerouslySetInnerHTML={{ __html: cellValue }} />
                      <LoadingButton
                        variant="transparent"
                        className="cursor-pointer text-primary ms-2"
                        onClick={() =>
                          setEditingCell({ row: "header", col: colIndex })
                        }
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          padding: "2px 4px"
                        }}
                      >
                        <Edit2 size={14} color="#333" />
                      </LoadingButton>
                    </div>
                  )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {Array.from({ length: type?.total_row || 0 }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: type?.total_column || 0 }).map(
                (_, colIndex) => {
                  const isEditing =
                    editingCell?.row === rowIndex &&
                    editingCell?.col === colIndex;
                  const cellValue =
                    chartData?.[rowIndex + 1]?.[colIndex] || "";

                  return (
                    <td
                      key={colIndex}
                      className="position-relative text-wrap"
                      style={{ width: "150px" }}
                    >
                      {isEditing ? (
                        <div className="d-flex align-items-center w-100">
                          <RichTextCell
                            value={cellValue}
                            onReady={(editor) => setActiveEditor(editor)}
                            onChange={() => handleSave(rowIndex + 1, colIndex, activeEditor)}
                          />
                          <LoadingButton
                            variant="transparent"
                            className="cursor-pointer text-success ms-2"
                            onClick={() =>
                              handleSave(rowIndex + 1, colIndex, activeEditor)
                            }
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              padding: "2px 4px"
                            }}
                          >
                            <Save size={14} color="#333" />
                          </LoadingButton>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-between align-items-center">
                          <div dangerouslySetInnerHTML={{ __html: cellValue }} />
                          <LoadingButton
                            variant="transparent"
                            className="cursor-pointer text-primary ms-2"
                            onClick={() =>
                              setEditingCell({ row: rowIndex, col: colIndex })
                            }
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              padding: "2px 4px"
                            }}
                          >
                            {colIndex === 0 && <Edit2 size={14} color="#333" />}
                          </LoadingButton>
                        </div>
                      )}
                    </td>
                  );
                }
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AssessmentTable;
